<template>
  <div>
    <a-form-model
      ref="addForm"
      :model="formData"
      :rules="rules"
      :disabled="$route.query.titless == '查看'"
      class="detail-form"
    >
      <div class="card-container">
        <div class="card-title subtitle">
          基础信息
        </div>
        <div>
          <div class="card-content">
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="循环商店名称"
                  prop="storeName"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.storeName"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写循环商店名称"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  label="店长"
                  prop="storeManager"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.storeManager"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写店长姓名"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <!-- 要添加一个查询是否有记录手机号的功能 -->
              <!-- <a-col :span="12">
                <a-form-model-item
                  label="手机号"
                  prop="mobile"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.mobile"
                    :value="inputVal"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写手机号"
                    @select="onSelect"
                  />
                </a-form-model-item>
              </a-col> -->
              <a-col :span="12">
                <a-form-model-item label="手机号" prop="mobile" v-bind="formItemLayout">
                  <a-select
                    v-decorator="[
                      'mobile',
                      {
                        rules: [
                          { required: true, message: '请输入或选择手机号' },
                          { validator: validatePhoneNum }
                        ]
                      }
                    ]"
                    :value="formData.mobile"
                    show-search
                    placeholder="请填写手机号"
                    style="width: 100%"
                    :filter-option="false"
                    :disabled="$route.query.titless == '查看'"
                    :not-found-content="fetching ? undefined : null"
                    @search="getMemberList"
                    @change="handleMemberChange"
                  >
                    <a-spin
                      v-if="fetching"
                      slot="notFoundContent"
                      size="small"
                    />
                    <a-select-option
                      v-for="d in recycleUserList"
                      :key="d.value"
                    >
                      {{ d.text }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  label="循环商店简介"
                  prop="synopsis"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.synopsis"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写店铺简介"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="循环商店类型"
                  v-bind="formItemLayout"
                  prop="storeType"
                >
                  <a-select
                    v-model="formData.storeType"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请选择"
                    allow-clear
                  >
                    <a-select-option
                      v-for="item in storeTypes"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="经营范围" v-bind="formItemLayout">
                  <a-input
                    v-model="formData.businessScope"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写商户经营范围"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="区域"
                  prop="area"
                  v-bind="formItemLayout"
                >
                  <a-cascader
                    v-model="formData.area"
                    v-decorator="[
                      'area',
                      { rules: [{ required: true, message: '请选择省市区' }] }
                    ]"
                    :disabled="$route.query.titless == '查看'"
                    :options="options"
                    :load-data="loadData"
                    :field-names="{
                      label: 'name',
                      value: 'id',
                      children: 'children'
                    }"
                    placeholder="省市区"
                    change-on-select
                    @change="changeArea"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  label="详细地址"
                  prop="address"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.address"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写详细地址"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="商店坐标"
                  prop="pos"
                  v-bind="formItemLayout"
                >
                  <a-input
                    v-model="formData.pos"
                    placeholder="点击打开地图，选择坐标"
                    :disabled="$route.query.titless == '查看'"
                    read-only
                    @click="choosePos"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="入驻日期" prop='settledTime' v-bind="formItemLayout">
                  <a-input
                    v-if="$route.query.titless === '查看'"
                    v-model="formData.settledTime"
                    :placeholder="
                      $route.query.titless === '查看' ? '' : '请选择入驻日期'
                    "
                    disabled
                  />
                  <a-date-picker
                    v-else
                    v-model="formData.settledTime"
                    show-time
                    type="date"
                    placeholder="请填写入驻日期"
                    format="YYYY-MM-DD"
                    style="width: 100%"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="营业开始时间"
                  prop="beginBusinessTime"
                  v-bind="formItemLayout"
                >
                  <a-time-picker
                    v-model="formData.beginBusinessTime"
                    :disabled="$route.query.titless == '查看'"
                    :disabled-date="disabledDate"
                    format="HH:mm"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  label="营业结束时间"
                  prop="endBusinessTime"
                  v-bind="formItemLayout"
                >
                  <a-time-picker
                    v-model="formData.endBusinessTime"
                    show-time
                    :disabled="$route.query.titless == '查看'"
                    format="HH:mm"
                    :disabled-date="disabledDate"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- 默认隐藏这一行，若用户手机号没有记录->显示 -->
            <a-row v-show="false">
              <a-col :span="12">
                <a-form-model-item
                  label="移动端用户名"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    v-model="formData.mobileUser"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写移动端用户名"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  v-show="true"
                  label="移动端密码"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input-password
                    v-model="formData.mobilePassword"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写移动端密码"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="备注" v-bind="formItemLayout">
                  <a-input
                    v-model="formData.remark"
                    :disabled="$route.query.titless == '查看'"
                    placeholder="请填写备注"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>

          <chooseSite
            ref="chooseMap"
            :map-dialog-obj="mapDialogObj"
            @getPosition="getPosition"
          />
        </div>
        <div
          v-if="!($route.query.titless == '查看' && fileList.length == 0)"
          class="card-title subtitle"
          style="margin-top: 40px"
        >
          资质信息
        </div>
        <div
          v-if="!($route.query.titless == '查看' && fileList.length == 0)"
          class="card-content"
        >
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                label="关联店铺照片"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-upload
                  :disabled="$route.query.titless == '查看'"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="true"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :remove="handleRemove"
                  :max-count="3"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <div v-if="$route.query.titless != '查看' && fileList.length < 3">
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      图片上传
                    </div>
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible"
                  centered
                  :footer="null"
                  @cancel="handleCancel"
                >
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
                <div class="upload-tip">
                  <a-icon
                    class="tip-icon"
                    type="info-circle"
                  />每张大小不超过1M，最多可以上传3张，格式为png，jpeg，jpg，第一张默认为主图。
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <!-- v-if="!($route.query.titless == '查看' && fileList.length == 0)" -->
        <div class="card-title subtitle" style="margin-top: 40px">
          管理回收点选择
        </div>
        <!-- 回收点树-->
        <div v-if="roleFindMenu.length > 0">
          <a-tree
            v-model="checkedMenuKeys"
            :checkable="$route.query.titless != '查看'"
            :default-expand-all="defaultExpandAll"
            :tree-data="roleFindMenu"
            @check="onCheckMenu"
          />
          <!-- <a-tree
            v-model="checkedKeys"
            :checkable="$route.query.titless != '查看'"
            :tree-data="treeData"
            :auto-expand-parent="autoExpandParent"
            :default-expand-all="defaultExpandAll"
            :replace-fields="replaceFields"
            :selected-keys="selectedKeys"
            @expend="onExpend"
            @check="onCheck"
          >
          </a-tree> -->
        </div>
        <!-- <div><a-tree :default-expand-all="true" :tree-data="roleFindMenuViews" /></div> -->
        <!-- 返回和保存 -->
        <div class="card-content mb40 mt40">
          <a-row type="flex" justify="center">
            <a-col
              :span="12"
              type="flex"
              align="middle"
              style="text-align: center"
            >
              <a-button class="mr8" @click="back">
                返回
              </a-button>
              <a-button
                v-if="$route.query.titless != '查看'"
                type="primary"
                @click="save"
              >
                保存
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form-model>
  </div>
</template>
<script>
import {
  savePostHouseStore,
  getPostHouseStore,
  findPostHouseStoreList,
  getPostHouseTree
} from "@/api/postManagement";
import { getRecycleUser } from "@/api/takeBack";
import imageUpload from "@/components/imageUpload/imageUpload.vue";
import moment from "moment";

import { getAreaList } from "@/api/common";
import {
  toExportExcel,
  getArea,
  getEstate
} from "@/components/mixins/mixins.js";
import chooseSite from "@/components/map/chooseSite.vue";
import debounce from "lodash/debounce";
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { imageUpload, chooseSite },
  mixins: [toExportExcel, getArea, getEstate],

  data() {
    this.lastFetchId = 0;
    this.getMemberList = debounce(this.getMemberList, 800);
    return {
      type: 2,
      fetching: false,
      recycleUserList: [],
      nodeList: [],
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => "共" + total + "条记录",
        pageSizeOptions: ["10", "20", "30", "40"],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      list: [], // 手机号历史记录
      estateList: [],
      formData: {
        storeName: "", // 商店名称
        storeManager: "", //店长
        businessScope: "", // 经营范围
        // userCellPhone: '',
        mobile: "",
        synopsis: "", // 简介
        area: [],
        address: "",
        pos: "",
        storeType: undefined,
        remark: "",
        paths: "",
        // estateId: undefined, // 小区
        mobileUser: "",
        mobilePassword: "",
        beginBusinessTime: "",
        endBusinessTime: "",
        settledTime: ""
        // managerId: ''
      },
      storeTypes: [
        {
          id: 1,
          name: "自营店"
        },
        {
          id: 2,
          name: "加盟店"
        }
      ],
      rules: {
        storeName: [
          { required: true, message: "请填写回收点名称", trigger: "blur" }
        ],
        storeManager: [
          { required: true, message: "请填写店长姓名", trigger: "blur" }
        ],
        mobile: [{ required: true, message: "请填写手机号", trigger: "blur" }],
        storeType: [
          { required: true, message: "请选择循环商店类型", trigger: "change" }
        ],
        area: [{ required: true, message: "请选择省市区", trigger: "change" }],
        // estateId: [{ required: true, message: '请填写小区', trigger: 'blur' }],
        address: [
          { required: true, message: "请填写详细地址", trigger: "blur" }
        ],
        pos: [
          {
            required: true,
            message: "点击打开地图，选择坐标",
            trigger: "change"
          }
        ],
        settledTime: [
          { required: true, message: "请填写入驻日期", trigger: "change" }
        ],
        beginBusinessTime: [
          { required: true, message: "请选择营业开始时间", trigger: "change" }
        ],
        endBusinessTime: [
          { required: true, message: "请选择营业结束.时间", trigger: "change" }
        ]
      },
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 }
      },
      fileList: [],
      loading: false,
      optionsItem: [],
      // eslint-disable-next-line vue/no-dupe-keys
      options: [],
      areaNames: [],
      area: [],
      mapDialogObj: {
        visible: false
      },
      previewVisible: false,
      previewImage: "",
      estatePerson: [],
      imgUp: "",
      positionInfo: null,
      visible: false,
      expandedKeys: [],
      checkedKeys: [], // 选中复选框的树节点
      selectedKeys: [], // 设置选中的树节点
      autoExpandParent: true, // 自动展开父节点
      defaultExpandAll: true, // 默认展开所有
      treeData: [],
      replaceFields: {
        key: "id",
        title: "name",
        children: "children"
      },
      checkedMenuKeys: [], //树形数据
      roleFindMenu: [],
      confirmCheckedMenuKeys: [],
      roleFindMenuViews: []
    };
  },
  computed: {
    inputVal() {
      return this.value !== null ? this.value : undefined;
    }
  },
  watch: {
    checkedKeys(val) {}
  },
  mounted() {
    this.getArea("", 2, null, true);
    if (this.$route.query.id) {
      this.getPostHouseStore(); // 获取循环商店信息
    }
    if (this.$route.query.titless === "查看") {
      this.findPostHouseStoreList(); // 循环商店列表
    }
    this.getPostHouseTree();
  },
  methods: {
    moment,

    // 获取循环商店列表信息
    findPostHouseStoreList() {
      this.loading = true;
      findPostHouseStoreList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        id: this.$route.query.id
      }).then(res => {
        this.loading = false;
        this.tableData = res.result;
        this.pagination.total = res.result.totalCount;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.findPostHouseStoreList();
    },
    // 获取循环商店信息
    getPostHouseStore() {
      const params = {
        id: this.$route.query.id
      };
      getPostHouseStore(params).then(res => {
        if (res.result.paths.length > 0) {
          res.result.paths.split(",").forEach(d => {
            this.fileList.push({
              uid: d,
              name: d,
              status: "done",
              url: d
            });
          });
        }

        this.checkedKeys = res.result.postHouseIds.split(",");
        this.checkedMenuKeys = res.result.postHouseIds.split(","); //测试0000000000000
        const area = [];
        area.push(res.result.provinceId, res.result.cityId, res.result.areaId);
        this.getAreaData(area[0]);

        //  this.formData.beginBusinessTime = res.result.beginBusinessTime
        //   this.formData.endBusinessTime = res.result.endBusinessTime

        this.formData.settledTime = res.result.settledTime;
        this.formData.storeName = res.result.storeName;
        this.formData.storeManager = res.result.storeManager;

        this.formData.mobile = res.result.mobile;
        this.formData.synopsis = res.result.synopsis;
        this.formData.businessScope = res.result.businessScope;

        this.formData.remark = res.result.remark;

        this.formData.name = res.result.name;
        this.formData.address = res.result.address;
        this.formData.storeType = res.result.storeType - 0;
        this.formData.pos = res.result.lo + "," + res.result.la;
        setTimeout(() => {
          this.$nextTick(() => {
            this.formData.area = [
              res.result.provinceId,
              res.result.cityId,
              res.result.areaId
            ];
          });
        }, 800);

        this.formData.beginBusinessTime = moment(
          res.result.beginBusinessTime,
          "HH:mm"
        );
        this.formData.endBusinessTime = moment(
          res.result.endBusinessTime,
          "HH:mm"
        );

        // if (area.length < 4) {
        //   this.getEstate(area);
        // } else if (area.length === 4) {
        //   this.getEstate(null, res.result.areaId);
        // }

        // this.changeArea('',this.options)
      });
    },

    // 手机号联想记录
    onSelect(value) {
      // 选中一个
      this.$emit("input", value); // 回显给输入框
    },

    disabledDate() {},
    // 图片上传
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file) {
      if (this.fileList.length >= 3) {
        this.$message.error("最多可上传3张图片！");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      const isType =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isLt2M) {
        this.$message.error("每张图片大小不能超过1M！");
        return false;
      }
      if (!isType) {
        this.$message.error("请选择png，jpeg，jpg格式图片上传！");
        return false;
      }
      return false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleRemove(file) {
      this.fileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.fileList.splice(index, 1);
        }
      });
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption);
    },

    getAreaData(provinceId) {
      const newOptions = JSON.parse(JSON.stringify([...this.options]));

      newOptions.forEach(item => {
        if (item.id === provinceId) {
          getAreaList({
            id: item.id,
            layer: 3
          }).then(resp => {
            item.children = resp.result.data;
            item.children.forEach(thing => {
              getAreaList({
                id: thing.id,
                layer: 4
              }).then(respo => {
                thing.children = respo.result.data;
              });
            });
          });
        }
      });
      this.options = newOptions;
    },
    changeArea(value, options) {
      this.areaNames = [];
      if (!options) return;
      options.forEach(item => {
        this.areaNames.push(item.name);
      });
    },
    // changeArea(value, options) {
    //   this.areaNames = [];
    //   this.estateList = [];
    //   this.formData.estateId = "";
    //   // this.form.setFieldsValue({ estateId: '' })
    //   if (value.length < 4) {
    //     this.getEstate(value);
    //   } else if (value.length === 4) {
    //     this.getEstate(null, value[3]);
    //   }
    //   if (!options) return;
    //   options.forEach(item => {
    //     this.areaNames.push(item.name);
    //   });
    // },
    getPosition(positionInfo) {
      // 获取地区选取信息
      if (positionInfo.point) {
        this.positionInfo = positionInfo.point;
        this.formData.pos =
          positionInfo.point.lng + "," + positionInfo.point.lat;
        // this.form.setFieldsValue({ pos: positionInfo.point.lng + ',' + positionInfo.point.lat })
      }
    },
    choosePos() {
      this.mapDialogObj.visible = true;
      this.$refs.chooseMap.initMap();
    },
    loadDataItem(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getCategory(targetOption.id, 2, targetOption);
    },

    getCategory(id, level, targetOption) {
      this.$httpPost(this.$basePath.getCategory, {
        pid: id
      }).then(res => {
        if (level === 1) {
          res.result.forEach(item => {
            item.isLeaf = false;
          });
          this.optionsItem = res.result;
        } else {
          this.$set(targetOption, "children", res.result);
        }
      });
    },
    handleChange({ file, fileList }) {
      if (this.fileList.length === 3) {
        return false;
      }
      var formdata = new FormData();
      formdata.append("file", file);
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$httpPost(this.$basePath.uploadImage, formdata, config).then(res => {
        this.imgUp = res.result;
        this.$message.success("上传成功！");
        fileList.forEach(item => {
          if (item.uid === file.uid) {
            Object.assign(item, {
              url: res.result
            });
          }
        });
        this.fileList = fileList;
      });
    },
    // 回收点树
    // handleTreeData(data) {
    //   for (var i = 0; i < data.length; i++) {
    //     if (data[i].children) {
    //       this.handleTreeData(data[i].children);
    //     } else {
    //       this.nodeList.push(data[i].id);
    //     }
    //   }
    // },
    validatePhoneNum(rule, value, callback) {
      const reg = /^[1][3-9][0-9]{9}$/;
      if (value.label && !reg.test(`${parseInt(value.label)}`)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    getMemberList(value) {
      if (!value) return;
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      const params = {
        isPostHouseStoreManager: 1,
        mobile: value
      };
      this.recycleUserList = [];
      this.fetching = true;
      getRecycleUser(params).then(res => {
        this.fetching = false;
        if (fetchId !== this.lastFetchId) {
          return;
        }
        const data = res.result.map(user => ({
          text: user.mobile,
          value: user.id
        }));
        this.recycleUserList = data;
        if (this.recycleUserList.length === 0) {
          this.formData.mobile = value;
          this.formData.managerId = "";
        }
        this.formData.mobile = value;
        this.fetching = false;
      });
    },
    handleMemberChange(value) {
      if (this.recycleUserList.length > 0) {
        this.recycleUserList.forEach(d => {
          if (value == d.value) {
            this.formData.mobile = d.text;
          }
        });
      }
      this.formData.managerId = value;
      Object.assign(this, {
        recycleUserList: [],
        fetching: false
      });
    },
    // 获取选中的回收点树信息
    getPostHouseTree() {
      const params = {
        id: this.$route.query.id,
        postHouseIds: this.postHouseIds
      };
      getPostHouseTree(params).then(res => {
        this.roleFindMenu = [];

        this.checkedMenuKeys = this.handleSelectData(
          res.result.postHouseAreaInfo,
          "checkedMenu"
        );

        let aa = [];

        if (this.$route.query.titless != "查看") {
          aa = this.hand(res.result.postHouseAreaInfo);
        } else {
          aa = this.examine(res.result.postHouseAreaInfo);
        }

        this.selectedData = this.handleDefSelectData(res.result, "checkedMenu");

        if (
          res.result.postHouseAreaInfo &&
          res.result.postHouseAreaInfo.length
        ) {
          aa.forEach(item => {
            this.roleFindMenu.push(this.handleTreeData(item));
          });
        }
      });
    },
    handleTreeData(item) {
      const childrenNode = {
        title: item.name,
        key: item.id,
        value: item.id,
        disabled: item.disabled
      };
      if (item.children && item.children.length) {
        childrenNode.children = [];
        item.children.forEach(subItem => {
          childrenNode.children.push(this.handleTreeData(subItem));
        });
      }
      return childrenNode;
    },
    onCheckMenu(checkedKeys, info) {
      // console.log(checkedKeys, info,'checkedKeys, infocheckedKeys, info')
      // 合并两个数组
      this.confirmCheckedMenuKeys = checkedKeys.concat(info.halfCheckedKeys);
    },
    // 查看
    // 处理默认选中的菜单 UI展示
    examine(items, flag) {
      const result = [];
      function filter(list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].isSelect == 1) {
            // result.push(list[i])
            list[i].disabled = false;
          } else {
            list[i].disabled = true;
            //  delete list[i]
            // result.push({id:list[i].id,disabled:true})
          }

          if (list[i] && list[i].children && list[i].children.length) {
            filter(list[i].children);
          }
        }
      }
      filter(items);
      return items;
    },
    hand(items) {
      const result = [];
      function filter(list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].isSelect == 2) {
            list[i].disabled = true
          // } else if (
          //   list[i].children &&
          //   list[i].children.length > 0 &&
          //   list[i].isSelect != 2
          // ) {
          //   list[i].children.forEach((value, index) => {
          //     if(value.children && value.children.length > 0){
          //           value.children.forEach((va, ind) => {
          //             if(va.isSelect != 2){
          //               va.disabled = false
          //               value.disabled = false
          //               list[i].disabled = false
          //             } else {
          //                 list[i].disabled = true
          //                 value.disabled = true
          //                  va.disabled = true
          //             }
          //         })
          //      }

          //   })
          } else {
            list[i].disabled = false
          }

          if (list[i].children && list[i].children.length) {
            filter(list[i].children)
          }
        }
      }
      filter(items);

      return items;
    },

    // 处理默认选中的菜单 UI展示
    handleSelectData(items, flag) {
      const result = [];
      function filter(list) {
        for (let i = 0; i < list.length; i++) {
          // if(list[i].isSelect == 1) {
          //    result.push(list[i].id)
          // } else if(list[i].isSelect == 2){
          //   result.push(list[i].id)
          // }
          if (
            ((list[i].children && list[i].children.length === 0) ||
              !list[i].children) &&
            list[i].isSelect
          ) {
            if (list[i].isSelect == 2) {
              list[i].disabled = true;
            } else if (list[i].isSelect == 1) {
              result.push(list[i].id);
            }
          }
          if (list[i].children && list[i].children.length) {
            filter(list[i].children);
          }
        }
      }
      filter(items);

      return result;
    },
    // 处理默认选中的菜单 提交服务器
    handleDefSelectData(items, flag) {
      const result = [];
      function filter(list) {
        for (let i = 0; i < list.length; i++) {
          if (
            (list[i].isSelected && flag === "normal") ||
            (list[i].isSelect && flag === "checkedMenu")
          )
            result.push(list[i].id);
          if (list[i].children && list[i].children.length) {
            filter(list[i].children);
          }
        }
      }
      filter(items);

      return result;
    },
    // 000000000000000000000000000000000000000000000000000
    // 展开/收起节点时触发
    onExpend(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    // onCheck(checkedKeys, info) {
    //   this.checkedKeys = checkedKeys;
    // },
    handleSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    compare(arr1, arr2) {
      return arr1.filter(v => {
        return arr2.includes(v);
      });
    },
    // 保存按钮
    save(e) {
      e.preventDefault();
      this.$refs.addForm.validate(valid => {
        // 表单的规则校验时触发
        if (valid) {
         
          if(this.confirmCheckedMenuKeys.length > 0){
             this.formData.postHouseIds = this.confirmCheckedMenuKeys.join(",");
          }
          //  else {
          //   this.formData.postHouseIds = this.checkedKeys.join(",")
          // }

          var param = JSON.parse(JSON.stringify(this.formData));
          if (this.$route.query.title) {
            param.id = this.$route.query.id;
            param.lo = param.pos.split(",", 2)[0];
            param.la = param.pos.split(",", 2)[1];
          } else {
            param.lo = this.positionInfo.lng;
            param.la = this.positionInfo.lat;
          }

          // 入驻时间
          param.settledTime
            ? (param.settledTime = moment(param.settledTime).format(
                "YYYY-MM-DD"
              ))
            : "";
          // 经营开始时间
          param.beginBusinessTime
            ? (param.beginBusinessTime = moment(param.beginBusinessTime).format(
                "HH:mm"
              ))
            : "";
          // 经营结束时间
          param.endBusinessTime
            ? (param.endBusinessTime = moment(param.endBusinessTime).format(
                "HH:mm"
              ))
            : "";

          param.beginBusinessTime = param.beginBusinessTime.slice(0, 5);
          param.endBusinessTime = param.endBusinessTime.slice(0, 5);
          param.provinceId = param.area[0];
          param.cityId = param.area[1];
          param.areaId = param.area[2];

          delete param.area;

          if (this.fileList.length > 0) {
            const paths = [];
            this.fileList.forEach(d => {
              paths.push(d.url);
            });
            param.paths = paths.toString();
          }

          savePostHouseStore(param).then(res => {
            this.$message.success(res.msg);
            this.$router.push({
              path: "/postManagement/storeManagement"
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.ant-calendar-picker {
  width: 100%;
}
.camera-body {
  width: 100%;
  // max-height: 32vh;
  // overflow: auto;
  margin-top: 3vh;
  padding: 0 0.2vw;
  box-sizing: border-box;
}

// .camera-body::-webkit-scrollbar{
//   width:10px;
// }
// .camera-body::-webkit-scrollbar-thumb{
//   background-color:#666;
//   border-radius: 10px;
// }
.camera-content {
  width: 100%;
  .camera-head {
    background: #eee;
    padding: 0.5vh 0.5vw;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: default;
    > span {
      font-size: 16px;
      font-weight: 700;
    }
    .close {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="stylus" scoped>
.card-title.subtitle {
  font-size: 14px;
}

.upload-tip {
  font-size: 12px;
  color: #999999;

  .tip-icon {
    margin-right: 6px;
  }
}
</style>
